import {
  AddressesAutocomplete,
  type AddressesAutocompleteProps,
} from '@/components/AddressesAutocomplete';

export type RenterInviteAddressesAutocompleteProps = AddressesAutocompleteProps;

export const RenterInviteAddressesAutocomplete = (
  props: RenterInviteAddressesAutocompleteProps,
) => {
  return (
    <AddressesAutocomplete
      color="secondary"
      {...props}
      inputSx={{
        '& .MuiFormLabel-asterisk': {
          color: 'red !important',
        },
        ...props.inputSx,
      }}
    />
  );
};
